export default "__VITE_ASSET__ugDnvXPq__"